import { styled } from '@mui/material';
import { css } from '@emotion/react';
import { UiIcon } from 'ui-components';
import { marginLeft } from 'utils';

export const StyledUiIcon = styled(UiIcon)(
  () => css`
    ${marginLeft('20px')}
  `
);
